export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14289.2054b35b.jpg";